export default __webpack_public_path__ + "static/store-galaxy.ja-67b9aa31488ea987150a9136801f0b11.png";